import { useCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

const useOpportunityLookupService = () => {
  const { search } = useCrudService({
    singleResourceUrl: '/crm/opportunities/:id',
    listResourceUrl: '/crm/opportunities',
    useService: useKernelApi,
  });

  return {
    search,
  };
};

export default useOpportunityLookupService;
